module.exports = __webpack_public_path__ + "static/media/acreto-logo.f34e150a.svg";